export const apiPath = '/v2/container_users';
const actionType = 'CONTAINER_CONTROL_USERS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
